module.exports = __webpack_public_path__ + "img/cover3.625da5b7.jpg";